import React from 'react';
import { useTranslation } from 'react-i18next';
import { currencies } from '../claimsHelpers';

import InputContainer from '../../../common2/InputContainer/InputContainer';

import SelectArrowsIcon from '../../../../icons/select-arrows.svg';

import styles from './OrderItemsCurrencyInput.scss';
import classNames from 'classnames';
import Text from '../../../common/Text';

interface OrderItemsCurrencyInputProps {
  label: string;
  isRequired?: boolean;
  error?: string;
  onChange: (values: { [key: string]: string }) => void;
  amount?: number | string | null;
  currency?: string;
  amountName: string;
  currencyName: string;
  noErrorTranslation?: boolean;
  readonlyNetValue?: boolean;
  isDisabled?: boolean;
}

function OrderItemsCurrencyInput(props: OrderItemsCurrencyInputProps) {
  const {
    label,
    isRequired,
    error,
    onChange,
    amount,
    currency,
    amountName,
    currencyName,
    noErrorTranslation,
    readonlyNetValue,
    isDisabled = false,
  } = props;

  const { t } = useTranslation();

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    onChange({ [e.target.name]: e.target.value });
  };

  const errorText = noErrorTranslation ? error : t(error || '');

  return (
    <InputContainer labelFor="" label={label} labelIsRequired={isRequired} errorWithTranslation={errorText}>
      <div className={styles.container}>
        <div className={styles.selectWrapper}>
          <select
            className={styles.select}
            value={currency}
            name={currencyName}
            onChange={onChangeHandler}
            disabled={isDisabled}
          >
            {currencies.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
          <div className={styles.arrowElement}>
            <SelectArrowsIcon />
          </div>
        </div>
        {!readonlyNetValue && (
          <input
            className={classNames(styles.input, { [styles.error]: error })}
            placeholder="0.0"
            value={amount || ''}
            name={amountName}
            onChange={onChangeHandler}
            disabled={isDisabled}
          />
        )}
        {readonlyNetValue && typeof amount === 'number' && (
          <Text className={styles.readonlyText} ink>
            {amount ? amount?.toFixed(2) : '0.00'}
          </Text>
        )}
      </div>
    </InputContainer>
  );
}

export default React.memo(OrderItemsCurrencyInput);
